export default __webpack_public_path__ + "static/media/reanimacion_sepsis.e4b272a7.pdf";